// should be moved to a separate feature folder e.g. upload
import { useMutation, MutationOptions } from '@tanstack/react-query';

import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

interface UploadData {
  file: File;
  key?: string;
  presignedUrl: string;
  headers?: Record<string, string | number>;
}

const useUploadFileMutation = (
  options: MutationOptions<any, Error, UploadData, unknown> = {}
) => {
  const { request: requestWithoutAuth } = useMutationHTTPRequest({
    isAuthRequired: false,
  });

  return useMutation(
    async ({ file, key, presignedUrl, headers = {} }: UploadData) =>
      await requestWithoutAuth({
        url: presignedUrl,
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type,
          'object-key': key,
          ...headers,
        },
        isHosApi: false,
      }),
    options
  );
};

export default useUploadFileMutation;
